import { Component } from '@angular/core';

import { UserService } from '../../services/user.service';
import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';
import { UserListItem } from '../../models/users/user-list-item.model';

@Component({
  selector: 'spv2-directory-users-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class DirectoryUsersDropdownComponent extends DropdownBaseComponent<string, UserListItem> {

  uniqueName = "directoryUsers";

  textField = "displayName";
  valueField = "mail";

  enableCache = false;
  minimumFilterLength = 3;
  allowCustom = true;

  dataFunction = (filter) => {
    return this.userService.getUserListFromDirectory(filter);
  };

  constructor(private userService: UserService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }
}
